<div class="actions clearfix">
    <label class="locale-label">{{locale.LABEL_LOCALE}}: </label>
    <select class="app-locale form-control app-select" [(ngModel)]="selectedLocale"
        (ngModelChange)="onLocaleChange(selectedLocale)">
        <option *ngFor="let key of supportedLocale" [value]="key">{{localeCodesMap[key]}}</option>
    </select>
    <wms-search width="20em" (onSearch)="filterPages($event)" placeholder="{{locale.LABEL_SEARCH}}"></wms-search>
</div>
<div class="localized-message-container">
    <table class="wm-table header-fixed">
        <thead>
            <tr>
                <th>{{locale.LABEL_APP_MESSAGE_KEY}} <span class="float-right category-actions" id="wms-new-page-btn">
                        <i class="wm-icon wms wms-plus btn button-primary" (click)="createNewLocaleMessage();"
                           title="{{locale.LABEL_PAGES_ADD_NEW}}"></i>
                      </span></th>
                <th>{{locale.LABEL_APP_DEFAULT_MESSAGE_VALUE}}</th>
            </tr>
        </thead>
        <tbody>
            <tr [ngClass]="{'active-label': message.active}"
                *ngFor="let message of messages |  orderBy: 'key' | filter:'key':pageSearchKey ; let i=index"
                (click)="onMessageSelect(message);">
                <td>{{message.key}}</td>
                <td>{{message.value}}</td>
            </tr>
        </tbody>
    </table>
</div>
